import React, {
  ButtonHTMLAttributes,
  PropsWithChildren,
  ReactNode,
} from "react";
import "./ButtonComponent.scss";
import IconButton from "./IconButton";
import LinkButton from "./LinkButton";
import NormalButton from "./NormalButton/NormalButton";

export type ButtonType =
  | "primary"
  | "secondary"
  | "tertiary"
  | "text"
  | "danger"
  | "link"
  | "icon-primary"
  | "icon-secondary"
  | "icon-ghost"
  | "icon-primary-circle";

export interface ButtonProps {
  /**Change the design of button*/
  type?: ButtonType;
  /**Is the button loading or not*/
  loading?: boolean;
  /**Type of component – button*/
  htmlType?: ButtonHTMLAttributes<any>["type"];
  /**Pass the classname to change the style of button*/
  className?: string;
  /**Function to be called when the button is clicked*/
  onClick?: ButtonHTMLAttributes<any>["onClick"];
  /** Size md for only button icon */
  size?: "lg" | "sm" | "md";
  children?: ReactNode;
  /**Disabled state of button*/
  disabled?: boolean;
  /**Set the icon of button*/
  icon?: JSX.Element;
  /**Set the icon of button*/
  iconPlace?: "left" | "right" | "both";
  /**Use stroke for color icon */
  isUseStrokeSvg?: boolean,
  /**link for button link */
  link?: string;
  /**link target */
  linkTarget?: "_blank" | "_self" | "_parent" | "_top";
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Button = (props: PropsWithChildren<ButtonProps>, ref: React.Ref<any>) => {
  const {
    type = "primary",
    htmlType = "button",
    disabled = false,
    size = "lg",
  } = props;
  if (
    type === "primary" ||
    type === "secondary" ||
    type === "tertiary" ||
    type === "text" ||
    type === "danger"
  ) {
    return (
      <NormalButton
        htmlType={htmlType}
        disabled={disabled}
        size={size}
        {...props}
      />
    );
  }

  if (type === "link") {
    return (
      <LinkButton
        htmlType={htmlType}
        disabled={disabled}
        size={size}
        {...props}
      />
    );
  }

  if (
    type === "icon-primary" ||
    type === "icon-secondary" ||
    type === "icon-ghost" ||
    type === "icon-primary-circle"
  ) {
    return (
      <IconButton
        htmlType={htmlType}
        disabled={disabled}
        size={size}
        {...props}
      />
    );
  }

  return <></>;
};
export default Button;
